import { render, staticRenderFns } from "./ivyPlayer.vue?vue&type=template&id=4b45829a&"
import script from "./ivyPlayer.vue?vue&type=script&lang=js&"
export * from "./ivyPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ivyPlayer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports